import useBaseRequest from "../../api/BaseRequest";
import { useAppDispatch } from "@grassrootly/rn-core";
import { GetMonthlyStats } from "@grassrootly/api/gateways/stats/GetMonthlyStats";
import { statsActions } from "../../api/stats/StatsReducer";
import { useUser } from "../../api/auth/AuthSelector";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { useFocusEffect } from "@react-navigation/native";

export function useMonthlyStats() {
  const dispatch = useAppDispatch();
  const player = useUser();
  const [month, setMonth] = useState<number>(moment().month() + 1);
  const [year, setYear] = useState<number>(moment().year());

  const { loading, data, execute } = useBaseRequest(GetMonthlyStats, {
    onCompleted: (data) => {
      if (!data) return;
      dispatch(statsActions.setMonthlyStats(data));
    },
  });

  const getMonthlyStats = useCallback(() => {
    execute({ playerId: player?.id, month, year });
  }, [month, year, player]);

  useEffect(() => {
    getMonthlyStats();
  }, [month, year]);

  useFocusEffect(getMonthlyStats);

  const nextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  const previousMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  return { stats: data, loading, nextMonth, previousMonth, year, month };
}
